function getCols() {
  const { download } = this;
  return [
    {
      key: 'isvName',
      width: '15%',
      title: '服务商名称',
      dataIndex: 'isvName',
    },
    {
      key: 'platformScore',
      width: '10%',
      title: '平台综合评分',
      dataIndex: 'platformScore',
    },
    {
      key: 'quotePrice',
      width: '10%',
      title: '需求报价',
      dataIndex: 'quotePrice',
    },
    {
      key: 'description',
      title: '方案描述',
      dataIndex: 'description',
    },
    {
      key: 'addr',
      width: '10%',
      title: '相关附件',
      cellRender(_, record) {
        return (
          <span>
            <a on-click={ () => {download(record.applyEnclosureUrl)} }>下载</a>
          </span>
        );
      },
    },
    // {
    //   title: '操作',
    //   cellRender(_, record) {
    //     return (
    //       <span>
    //         <a >选择该服务商</a>
    //       </span>
    //     );
    //   },
    // },
  ]
}

function getScoreCols() {
  return [
    {
      key: 'role',
      title: '角色',
      dataIndex: 'role',
    },
    {
      key: 'reviewerId',
      title: '工号',
      dataIndex: 'reviewerId',
    },
    {
      key: 'reviewerName',
      title: '姓名',
      dataIndex: 'reviewerName',
    },
  ]
}

function getScoreResCols() {
  const { viewScoreDetail } = this;

  return [
    {
      key: 'isvName',
      width: '20%',
      title: '服务商名称',
      dataIndex: 'isvName',
    },
    {
      key: 'platformScore',
      width: '15%',
      title: '平台综合分',
      dataIndex: 'platformScore',
    },
    {
      key: 'avgPriceScore',
      width: '15%',
      title: '价格分',
      dataIndex: 'avgPriceScore',
    },
    {
      key: 'avgProgrammeScore',
      width: '15%',
      title: '方案分',
      dataIndex: 'avgProgrammeScore',
    },
    {
      key: 'averageScore',
      width: '15%',
      title: '平均分',
      dataIndex: 'averageScore',
    },
    {
      title: '评审意见',
      cellRender(text, record) {
        return (
          <a on-click={ () => { viewScoreDetail(record) }}>查看</a>
        )
      }
    },
  ]
}

function getScoreDetailCols() {
  return [
    {
      key: 'signRoleName',
      width: '10%',
      title: '角色',
      dataIndex: 'signRoleName',
    },
    {
      key: 'signUserNum',
      width: '10%',
      title: '工号',
      dataIndex: 'signUserNum',
    },
    {
      key: 'signUserName',
      width: '10%',
      title: '姓名',
      dataIndex: 'signUserName',
    },
    {
      key: 'platformScore',
      width: '10%',
      title: '平台综合评分',
      dataIndex: 'platformScore',
    },
    {
      key: 'priceScore',
      width: '10%',
      title: '价格分',
      dataIndex: 'priceScore',
    },
    {
      key: 'programmeScore',
      width: '10%',
      title: '方案分',
      dataIndex: 'programmeScore',
    },
    {
      key: 'averageScore',
      width: '10%',
      title: '平均分',
      dataIndex: 'averageScore',
    },
    {
      key: 'scoreRemarks',
      title: '备注',
      dataIndex: 'scoreRemarks',
    },
  ]
}

export {
  getCols,
  getScoreCols,
  getScoreResCols,
  getScoreDetailCols
}